import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import { Group } from "@mantine/core";
import Text from "../Text";

export const ModalHeader = ({ title, svgAsset, testId }: { title: string; svgAsset: string; testId?: string }) => {
  return (
    <Group>
      <SVGAsset name={svgAsset} />
      <Text size="xl" data-testid={testId}>
        {title.toUpperCase()}
      </Text>
    </Group>
  );
};

export default ModalHeader;
